import { useQuery } from '@tanstack/react-query';
import { ServiceAgreement } from '../../../../src/views/customers/details/tabs-panel/service-agreements-panel/types/index';
import { fetchServiceAgreements } from 'stores/queries/service-agreements/service-agreement-queries';

export const useFetchServiceAgreements = ({ customerId }: { customerId: string }) =>
  useQuery({
    queryFn: async () => (await fetchServiceAgreements({ customerId }))?.data as ServiceAgreement[],
    queryKey: ['service-agreements', customerId],
  });
